"use strict";

exports.__esModule = true;
exports["default"] = exports.TabBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _tab = _interopRequireDefault(require("./tab"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Fieldset = _styledComponents["default"].fieldset.withConfig({
  displayName: "tab-bar__Fieldset",
  componentId: "sc-1hrslzj-0"
})(["border:none;display:flex;flex-direction:column;margin:0;padding:0;", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "opacity: 0.6;" : null;
});

var BarContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "tab-bar__BarContainer",
  componentId: "sc-1hrslzj-1"
})(["overflow:hidden;"]);
var propTypes = {
  /** List of active options */
  activeValues: (0, _propTypes.arrayOf)(_propTypes.string),

  /** Font styles for button */
  buttonFont: _utils.fontPropType,

  /** Boolean for if tab bar is disabled */
  disabled: _propTypes.bool,

  /** Label for entire bar */
  groupLabel: _propTypes.node,

  /** Name for group of tabs */
  groupName: _propTypes.string,

  /** Font styles for label */
  labelFont: _utils.fontPropType,

  /** List of options, either array or object  */
  options: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object]),

  /** Selected value */
  selectedOption: _propTypes.string,

  /** Change handler for the input field */
  tabBarOnChange: _propTypes.func,

  /** Value for the text input - managed outside the component */
  topLabel: _propTypes.node,

  /** Width of bar */
  width: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string])
};

var TabBar = function TabBar(_ref2) {
  var buttonFont = _ref2.buttonFont,
      _ref2$labelFont = _ref2.labelFont,
      labelFont = _ref2$labelFont === void 0 ? _utils.defaultFontSize : _ref2$labelFont,
      disabled = _ref2.disabled,
      groupLabel = _ref2.groupLabel,
      groupName = _ref2.groupName,
      options = _ref2.options,
      width = _ref2.width,
      selectedOption = _ref2.selectedOption,
      tabBarOnChange = _ref2.tabBarOnChange;
  return /*#__PURE__*/_react["default"].createElement(Fieldset, {
    disabled: disabled,
    tag: "fieldset",
    width: width
  }, groupLabel ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    px: [3, 3, 0],
    tag: "legend"
  }, labelFont), groupLabel) : null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    px: [3, 3, 0],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(BarContainer, {
    alignItems: "stretch",
    border: "solid 1px",
    borderColor: "blue",
    borderRadius: 8,
    height: 48,
    justifyContent: "stretch",
    width: 1
  }, (0, _utils.mapIndexed)(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(_tab["default"], {
      key: option.id,
      disabled: disabled || option.disabled,
      fontObject: buttonFont,
      groupName: groupName,
      id: option.id,
      isChecked: selectedOption === option.value,
      label: option.label,
      last: i === options.length - 1,
      onChange: function onChange(event) {
        return (0, _ramda.not)(option.disabled) && tabBarOnChange(Object.assign({
          event: event
        }, option));
      },
      value: option.value
    });
  }, options))));
};

exports.TabBar = TabBar;
TabBar.propTypes = propTypes;
TabBar.displayName = "Modules.TabBar)";
var _default = TabBar;
exports["default"] = _default;